import { getIdToken } from 'firebase/auth';
import { auth } from './firebase.helper';

// eslint-disable-next-line no-undef
const BASE_URL = process.env.REACT_APP_BASE_URL;
// const BASE_URL = 'http://127.0.0.1:5001/detalks-test-23af7/asia-south1/api/';

export const makePost = async (url, data, headers = {}) => {
  const token = auth.currentUser ? await getIdToken(auth.currentUser) : '';
  return fetch(`${BASE_URL}${url}`, {
    method: 'POST',
    body: JSON.stringify(data),
    headers: {
      'Content-Type': 'application/json',
      authorization: `Bearer ${token}`,
      ...headers
    }
  });
};

export const makeGet = async (url, headers = {}) => {
  const token = auth.currentUser ? await getIdToken(auth.currentUser) : '';
  return fetch(`${BASE_URL}${url}`, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      authorization: `Bearer ${token}`,
      ...headers
    }
  });
};

export const getOrg = (orgCode) => {
  const url = `organisation/${orgCode}`;
  return makeGet(url);
};

export const getIntakeForm = (orgCode) => {
  const url = `organisation/${orgCode}/intake-form`;
  return makeGet(url);
};

export const getOrgDetails = (orgCode) => {
  const url = `organisation/${orgCode}/details`;
  return makeGet(url);
};

export const getCertificate = (orgCode, certificateId) => {
  const url = `organisation/${orgCode}/certificates/${certificateId}`;
  return makeGet(url);
};

export const getPost = (orgCode, postSlug) => {
  const url = `organisation/${orgCode}/posts/${postSlug}`;
  return makeGet(url);
};

export const initCourse = (orgCode, course) => {
  const url = `organisation/${orgCode}/course/${course}/init`;
  return makeGet(url);
};

export const initSelfAssessment = (orgCode, assessment, data) => {
  const url = `organisation/${orgCode}/self-assessments/${assessment}/init`;
  return makePost(url, data);
};

export const getCourseActivity = (orgCode, courseActivity) => {
  const url = `organisation/${orgCode}/course/activity/${courseActivity}`;
  return makeGet(url);
};

export const initCourseAssessment = (orgCode, courseActivity, sectionId) => {
  const url = `organisation/${orgCode}/course/${courseActivity}/${sectionId}/assessment/init`;
  return makeGet(url);
};

export const quizSubmit = (orgCode, courseActivity, data) => {
  const url = `organisation/${orgCode}/course/${courseActivity}/quiz`;
  return makePost(url, data);
};

export const saveCourseVideoProgress = (orgCode, courseActivity, sectionId, data) => {
  const url = `organisation/${orgCode}/course/${courseActivity}/${sectionId}`;
  return makePost(url, data);
};

export const registerClient = (data) => {
  const url = `register/client`;
  return makePost(url, data);
};

export const getAllTherapists = (orgCode) => {
  const url = `organisation/${orgCode}/therapists`;
  return makeGet(url);
};

export const getAllSelfAssessments = (orgCode) => {
  const url = `organisation/${orgCode}/self-assessments`;
  return makeGet(url);
};

export const getAllCourses = (orgCode) => {
  const url = `organisation/${orgCode}/courses`;
  return makeGet(url);
};

export const getTherapistDetails = (orgCode, practitionerId) => {
  const url = `organisation/${orgCode}/therapists/${practitionerId}`;
  return makeGet(url);
};
export const initHelpline = (orgCode) => {
  const url = `organisation/${orgCode}/helpline`;
  return makePost(url);
};

export const getMeetingDetails = (orgCode, practitionerId, serviceId, locationId) => {
  const url = `organisation/${orgCode}/therapists/${practitionerId}/${serviceId}/${locationId}`;
  return makeGet(url);
};

export const getSelfAssessment = (orgCode, assessmentSlug) => {
  const url = `organisation/${orgCode}/self-assessments/${assessmentSlug}`;
  return makeGet(url);
};

export const getSelfAssessmentDetails = (orgCode, assessmentSlug) => {
  const url = `organisation/${orgCode}/self-assessments/${assessmentSlug}/details`;
  return makeGet(url);
};

export const getTherapistAvailability = (practitionerId, data) => {
  const url = `organisation/therapists/${practitionerId}/availability`;
  return makePost(url, data);
};

export const confirmBooking = (orgCode, practitionerId, data) => {
  const url = `organisation/${orgCode}/therapists/${practitionerId}/meeting/book`;
  return makePost(url, data);
};

export const sendEmailVerificationOtp = (data) => {
  const url = `client/generate-otp`;
  return makePost(url, data);
};

export const verifyEmailOtp = (data) => {
  const url = `client/verify-otp`;
  return makePost(url, data);
};

export const checkUserExists = (data) => {
  const url = `client/check-user-exists`;
  return makePost(url, data);
};

export const startClientGoogleCalendarIntegration = (data) => {
  const url = `client/integrate/google-calendar/start`;
  return makePost(url, data);
};

export const getClientGoogleCalendarIntegrationStatus = () => {
  const url = `client/integrate/google-calendar/status`;
  return makeGet(url);
};

export const disconnectClientGoogleCalendarIntegration = () => {
  const url = `client/integrate/google-calendar/disconnect`;
  return makePost(url);
};
